import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const digitalGalleryApi = createApi({
    reducerPath: 'digitalGalleryApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/umbraco/api/DigitalGalleryApi',
    }),
    tagTypes: ['Shelves'],
    endpoints(builder) {
        return {
            getSkeletonShelves: builder.query({
                query: ({ pageId }) => `/GetSkeletonShelves?pageId=${pageId}`,
                providesTags: ['Shelves'],
                transformResponse: (response: any) => {
                    const shelfList = response?.shelfList || response?.ShelfList || [];
                    return shelfList.map((shelf: any) => ({
                        ...shelf,
                        isLoaded: false,
                        loadError: false,
                        digitalShelfItems: [],
                        itemCount: 4 
                    }));
                }
            }),

            getShelfItems: builder.query({
                query: ({ pageId, shelfName }) => `/GetShelf?pageId=${pageId}&shelfName=${shelfName}`,
                transformResponse: (response: any) => Array.isArray(response) ? response : [],
                // @ts-ignore
                invalidatesTags: ['Shelves'],
            }),


        };
    },
});

export const {
    useGetSkeletonShelvesQuery,
    useGetShelfItemsQuery,
    useLazyGetShelfItemsQuery
} = digitalGalleryApi;